import React from 'react';

function Banner() {
    return (
        <div className="banner container-fluid d-flex align-items-center justify-content-center">
            <img src={`${process.env.PUBLIC_URL}/assets/images/lifestyle.png`} alt="Peak & Pine Banner" className="img-fluid-banner" />
            <div className="text-content position-absolute text-white">
                <h1 className="banner-title">Kids & Sport Physio</h1>
            </div>
        </div>
    );
}

export default Banner;
